var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.7527 7.40538C29.5976 6.03227 27.465 5.47217 23.3921 5.47217H8.60759C4.4415 5.47217 2.27272 6.0684 1.12196 7.53028C0 8.95563 0 11.0558 0 13.9624V19.5024C0 25.1335 1.3312 27.9925 8.60759 27.9925H23.3922C26.9242 27.9925 28.8813 27.4983 30.1475 26.2865C31.446 25.0439 32 23.015 32 19.5024V13.9624C32 10.8971 31.9132 8.78458 30.7527 7.40538ZM20.5441 17.4973L13.8305 21.006C13.6804 21.0845 13.5163 21.1234 13.3524 21.1234C13.1668 21.1234 12.9816 21.0734 12.8175 20.9741C12.5087 20.787 12.3201 20.4522 12.3201 20.0911V13.0961C12.3201 12.7357 12.5082 12.4012 12.8164 12.2139C13.1247 12.0267 13.5082 12.0139 13.8281 12.1801L20.5417 15.6662C20.8833 15.8436 21.0978 16.1962 21.0983 16.5809C21.0987 16.9659 20.8852 17.3191 20.5441 17.4973Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.d2a92516e29debc3c2d8d576570f4350.svg";
export { ForwardRef as ReactComponent };